module.exports = __webpack_public_path__ + "img/delete.a2d9f93b.svg";